(() => {
  const config = document.getElementById('pluffi-cart-copy');
  if (!config) return;
  const entries = JSON.parse(config.textContent);
  const exact = new Map(entries.filter(([source]) => !source.includes('__TITLE__')));
  const remove = entries.find(([source]) => source.includes('__TITLE__'))?.[1];
  const replace = value => {
    const text = value.trim();
    if (exact.has(text)) return value.replace(text, exact.get(text));
    if (remove && text.startsWith('Remove ')) return remove.replace('__TITLE__', text.slice(7));
    if (text.startsWith('Add to cart: ')) return (exact.get('Add') || 'Add') + ' : ' + text.slice(13);
    return value;
  };
  const translate = () => {
    document.querySelectorAll('header, cart-drawer-component, cart-items-component').forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (node.parentElement.closest('script, style, template')) continue;
        const next = replace(node.textContent);
        if (next !== node.textContent) node.textContent = next;
      }
      root.querySelectorAll('[aria-label],[title]').forEach(el => {
        for (const attr of ['aria-label','title']) {
          const value = el.getAttribute(attr);
          if (value && replace(value) !== value) el.setAttribute(attr, replace(value));
        }
      });
    });
  };
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; translate(); });
  }).observe(document.body, {subtree:true,childList:true,characterData:true});
  translate();
})();
